<template>
  <dropdown class="marketing-email-list-item-actions"
            :data-border="false"
            dataMenuWidth="115px"
            data-icon="mdi-dots-vertical"
            @hidden="hideEveryModal">

    <p v-if="!hideEdit"
       class="marketing-email-list-item-actions-item pointer"
       @click.stop="goToAutomationDetail">
      {{$t('message.generics.message.edit')}}
    </p>

    <p class="marketing-email-list-item-actions-item pointer"
       @click="showRenameAutomationModal">
        {{$t('message.automation.message.rename')}}
    </p>

    <p class="marketing-email-list-item-actions-item pointer"
       @click="duplicateAutomation">
        {{$t('message.generics.message.duplicate')}}
    </p>

    <p v-if="!hideDelete"
       class="marketing-email-list-item-actions-item pointer"
       @click.stop="showDeleteModal">
        {{$t('message.generics.message.delete')}}
    </p>

    <confirmation-modal :value="showAutomationDeleteModal"
                        :confirm-label="$t('message.generics.message.confirm')"
                        @confirm="deleteAutomation"
                        @cancel="closeDeleteModal">
      <span slot="heading">
        {{$t('message.automation.message.deleteAutomation')}}
      </span>
      <span>
        {{$t('message.automation.message.deleteAutomationConfirmation')}}
      </span>
    </confirmation-modal>

    <marketing-automation-edit-name-modal :name="item.name"
                                          :automation-id="item.id"
                                          :showing.sync="showingAutomationNameEditModal"
                                          @edited="closeNameEditModal" />

  </dropdown>
</template>

<script>
import MarketingAutomationEditNameModal from "@components/modules/marketing/automation/edit/name/modal/MarketingAutomationEditNameModal";
import ConfirmationModal from "@components/ConfirmationModal";
import Dropdown from "@components/Dropdown";
import EventBus from "@packages/event-bus";

export default {
  components: {
    Dropdown,
    ConfirmationModal,
    MarketingAutomationEditNameModal,
  },
  data() {
    return {
      showAutomationDeleteModal: false,
      showingAutomationNameEditModal: false,
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hideEdit() {
      return (
        this.item.status === "SENT" ||
        this.item.status === "PARTIALLY_SENT_BY_CREDIT" ||
        this.item.status === "PARTIALLY_SENT_BY_SYSTEM"
      );
    },
    hideDelete() {
      return (
        this.item.status === "SENT" ||
        this.item.status === "PARTIALLY_SENT_BY_CREDIT" ||
        this.item.status === "PARTIALLY_SENT_BY_SYSTEM"
      );
    },
  },
  methods: {
    showRenameAutomationModal() {
      this.showingAutomationNameEditModal = true;
    },
    closeNameEditModal() {
      this.showingAutomationNameEditModal = false;
      this.emitEdited();
    },
    hideEveryModal() {
      this.closeDeleteModal();
    },
    showDeleteModal() {
      this.showAutomationDeleteModal = true;
    },
    closeDeleteModal() {
      this.showAutomationDeleteModal = false;
    },
    async deleteAutomation() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        await this.$api.marketing.automation.flow.delete({
          automationId: this.item.id,
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t('message.successMessages.message.automationDeleted'),
        });

        this.closeDeleteModal();

        this.$emit("deleted");
      } catch (error) {
        //empty
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    async duplicateAutomation() {
      await this.$api.marketing.automation.flow.duplicate({
        automationId: this.item.id,
      });

      this.$emit("duplicated");
    },
    goToAutomationDetail() {
      this.$router.push({
        path: `/marketing/automacao/${this.item.id}`,
      });
    },
    emitEdited() {
      this.$emit("edited");
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-list-item-actions {
  .marketing-email-list-item-actions-item {
    margin-bottom: 0px;
    font-size: 12px;
    color: #707070;
    font-weight: 600;
    margin-bottom: 5px;

    &:hover {
      transform: translateY(-1px);
    }

    &:active {
      box-shadow: none;
      transform: translateY(1px);
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
